import {
  ChevronLeftIcon,
  ChevronRightIcon,
  Box,
  CloseIcon,
  Tooltip,
} from "native-base";
import { Media } from "../../AVCore/Media";
import { AHStack, AVBox, AVPressable, AVStack } from "../../components/ui";
import fullscreenimage from "../../assets/images/fullscreen.png";
import normalscreen from "../../assets/images/normalscreen.png";
import React, { useEffect, memo, FC } from "react";
import { Pressable, Linking } from "react-native";
import { Dimensions } from "react-native";
import * as AV from "../../AVCore/AVCore";
import settings from "../../Platform/settings.json";
import { useLocation } from "react-router-dom";
import { DownloadIcon } from "../../assets/icons/icon-assets";
import GridView from "../posts/GridView";

interface Props {
  slideItems: any | undefined;
  previewitem: any | undefined;
  setpreviewitem: any | undefined;
  type: any | undefined;
  settype: any | undefined;
  fullscreen: any | undefined;
  setIsFullScreen: any | undefined;
  setShowDetails: any | undefined;
  setIscommentItem: any | undefined;
  setIsCommentSlider: any | undefined;
  isCommentSlider: any | undefined;
  handleslideChange: any | undefined;
  isHeader: any | undefined;
  setShowPreview: any | undefined;
  setHeader: any | undefined;
  setCommentValue: any | undefined;
  setClickedUrl?: React.Dispatch<React.SetStateAction<string>>;
  setShowConfirmLinkPopup?: React.Dispatch<React.SetStateAction<boolean>>;
}

const AVImageSlider: FC<Props> = ({
  slideItems,
  previewitem,
  setpreviewitem,
  type,
  settype,
  fullscreen,
  setIsFullScreen,
  setShowDetails,
  setIscommentItem,
  setIsCommentSlider,
  isCommentSlider,
  handleslideChange,
  isHeader,
  setShowPreview,
  setHeader,
  setCommentValue,
  setClickedUrl,
  setShowConfirmLinkPopup,
}) => {
  const [videoUrls, setVideoUrl] = React.useState(
    slideItems?.galleryPost ? slideItems?.galleryPost : slideItems,
  );
  const location: any = useLocation();
  const val = slideItems?.galleryPost?.filter(
    (x) => x?.id === slideItems?.media?.id,
  );
  let mediavalue: any = [];
  mediavalue.push(slideItems);
  let slides =
    (val?.length === 0 || val == undefined) && slideItems?.media
      ? mediavalue
      : slideItems?.galleryPost?.length > 0
        ? slideItems?.galleryPost
        : slideItems;
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [play, setplay] = React.useState(
    slides?.length > 0 ? slides[0] : slides,
  );
  const [imageVIdeo, setimageVIdeo] = React.useState([]);
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 500 || false;
  const [videoStatus, setVideoStatus] = React.useState<any>("");
  const [videoItem, setVideoItem] = React.useState<any>("");

  const goToPrevious = () => {
    setCommentValue("");
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    if (slides[0]?.type?.startsWith("video")) {
      setVideoUrl(slides[newIndex]);
      setplay(slides[newIndex]);
      setpreviewitem(slides[newIndex]);
    }
    setplay(slides[newIndex]);
    setpreviewitem(slides[newIndex]);
    setCurrentIndex(newIndex);
    handleslideChange();
  };

  const goToNext = () => {
    setCommentValue("");
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    if (slides[0]?.type?.startsWith("video")) {
      setVideoUrl(slides[newIndex]);
      setplay(slides[newIndex]);
      setpreviewitem(slides[newIndex]);
    }
    setplay(slides[newIndex]);
    setpreviewitem(slides[newIndex]);
    setCurrentIndex(newIndex);
    handleslideChange();
  };

  const handledocument = async (item) => {
    let val = await AV.Media.getFile(
      item?.media?.mListId,
      item?.media?.id,
      item?.media?.storeId,
    );
    if (val) {
      var blobUrl = val;
      var fileName = item?.media?.orgFile;
      var a = document.createElement("a");
      a.href = blobUrl.toString();
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      //window.open(val);
    }
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  const getFileSource = (file: any = {}) => {
    const fileType: any = file?.type || "";

    if (typeof fileType !== "string" || !fileType) {
      console.error("Invalid or missing file type.");
      return ""; // Return default value or handle error as needed
    }
    if (fileType === "application/pdf") {
      return settings?.pdf;
    } else if (
      fileType === "application/msword" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return settings?.word;
    } else if (
      fileType === "application/vnd.ms-powerpoint" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ) {
      return settings?.powerpoint;
    } else if (
      fileType === "application/vnd.ms-excel" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      return settings?.excel;
    } else if (fileType === "text/plain") {
      return settings?.file;
    } else {
      return ""; // or any default value if needed
    }
  };

  const imageeeUrl: any =
    slides != undefined
      ? slides?.length > 0 &&
        slides[currentIndex]?.media?.linkURL &&
        slides[currentIndex]?.media?.type !== "dropbox"
        ? slides[currentIndex]?.media?.linkURL
        : slides[currentIndex]?.media?.linkURL &&
            slides[currentIndex]?.media?.type == "dropbox"
          ? slides[currentIndex]?.media?.orgFile
          : slides[currentIndex]?.media?.type?.startsWith("image")
            ? Media.getURL(slides[currentIndex]?.media)
            : getFileSource(slides[currentIndex]?.media)
      : null;

  // Move this state update to useEffect
  useEffect(() => {
    if (type !== "ALL" && slides?.length > 0) {
      setpreviewitem(slides[currentIndex] ? slides[currentIndex] : play);
    }
  }, [type, slides, currentIndex, play, setpreviewitem]);

  const LinkIcon = () => {
    return (
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="#888888">
        <path d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" />
      </svg>
    );
  };

  type SimpleLinkPreviewProps = {
    url?: any;
    setClickedUrl?: React.Dispatch<React.SetStateAction<string>>;
    setShowConfirmLinkPopup?: React.Dispatch<React.SetStateAction<boolean>>;
  };

  const SimpleLinkPreview: FC<SimpleLinkPreviewProps> = memo(
    ({ url, setClickedUrl, setShowConfirmLinkPopup }) => {
      const postRef = React.useRef<HTMLDivElement | null>(null);

      React.useEffect(() => {
        const el = postRef.current;
        if (!el) return;

        const handleLinkClick = (e: MouseEvent) => {
          const target = e.target as HTMLElement;
          const anchor = target.closest("a");

          if (anchor) {
            e.preventDefault();
            e.stopPropagation();
            const href = (anchor as HTMLAnchorElement).href;
            if (href) {
              setClickedUrl?.(href);
              setShowConfirmLinkPopup?.(true);
            }
          }
        };

        el.addEventListener("click", handleLinkClick);
        return () => el.removeEventListener("click", handleLinkClick);
      }, []);

      return (
        <div className="link-preview-wrapper" ref={postRef}>
          <div className="link-preview-image">
            {url?.orgFile ? (
              <img src={url.orgFile} alt="Preview" />
            ) : (
              <div className="link-icon-container">
                <LinkIcon />
              </div>
            )}
          </div>
          <div className="link-preview-content">
            <p className="link-url">
              <a href={url?.linkURL} target="_blank" rel="noreferrer">
                {url?.linkURL}
              </a>
            </p>
          </div>
        </div>
      );
    },
  );

  return (
    <>
      {type === "ALL" && (
        <>
          <GridView
            item={slideItems}
            setVideoStatus={setVideoStatus}
            setVideoItem={setVideoItem}
            isPreview={
              previewitem !== undefined &&
              previewitem?.id?.length > 0 &&
              slideItems?.length === 0
                ? true
                : false
            }
          />
        </>
      )}

      {type !== "ALL" && (
        <div
          style={{
            position: isHeader ? "fixed" : "relative",
            height: isHeader ? "" : "100%",
            backgroundColor: isHeader ? "black" : "",
            top: isHeader ? "0px" : "",
            left: isHeader ? "0px" : "",
            right: isHeader ? "0px" : "",
            bottom: isHeader ? "0px" : "",
            zIndex: 999999,
          }}
        >
          <div>
            {slides?.length > 1 && (
              <>
                <div
                  onClick={goToPrevious}
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translate(0, -50%)",
                    left: "15px",
                    fontSize: "45px",
                    color: "#fff",
                    zIndex: 1,
                    cursor: "pointer",
                  }}
                >
                  <ChevronLeftIcon size={"30px"} color={"#fff"} />
                </div>
                <div
                  onClick={goToNext}
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translate(0, -50%)",
                    right: "15px",
                    fontSize: "45px",
                    color: "#fff",
                    zIndex: 1,
                    cursor: "pointer",
                  }}
                >
                  <ChevronRightIcon size={"30px"} color={"#fff"} />
                </div>
              </>
            )}
          </div>{" "}
          )
          {previewitem?.media?.id &&
            (previewitem?.media?.type?.startsWith("image") ||
              previewitem?.media?.type == "iframe" ||
              previewitem?.media?.type == "dropbox" ||
              previewitem?.media?.type == "Onedrive" ||
              previewitem?.media?.type == "linkPreview") && (
              <>
                {slides?.length >= 1 ? (
                  <div
                    className={
                      fullscreen
                        ? "fullscreen-image-container"
                        : isHeader
                          ? "image-containerHeader"
                          : "image-container"
                    }
                  >
                    {!fullscreen && !isHeader && (
                      <>
                        {!slides[currentIndex]?.media?.linkURL && (
                          <AHStack position={"absolute"} right={"0"} top={"0"}>
                            <Pressable
                              onPress={() => {
                                setIsFullScreen(true);
                              }}
                            >
                              <img
                                src={fullscreenimage}
                                height={"25px"}
                                width={"25px"}
                              />
                            </Pressable>
                          </AHStack>
                        )}

                        {slides[currentIndex]?.media?.linkURL && (
                          <AHStack
                            position={"absolute"}
                            right={"30px"}
                            top={"0"}
                          >
                            <Pressable
                              onPress={() =>
                                Linking.openURL(
                                  slides[
                                    currentIndex
                                  ]?.media?.orgFile?.startsWith("GoogleDrive")
                                    ? slides[currentIndex]?.media?.linkURL
                                    : slides[currentIndex]?.media?.orgFile,
                                )
                              }
                            >
                              <img
                                src="https://www.shutterstock.com/image-vector/external-link-icon-on-grey-260nw-2005883333.jpg"
                                height={"50px"}
                                width={"50px"}
                              />
                            </Pressable>
                          </AHStack>
                        )}
                      </>
                    )}

                    {isHeader && (
                      <AHStack position={"absolute"} right={"0"} top={"0"}>
                        <Pressable
                          onPress={() => {
                            setShowPreview(false);
                            setHeader(false);
                          }}
                        >
                          <CloseIcon size="15px" color={"white"} />
                        </Pressable>
                        {slides[currentIndex]?.media?.linkURL && (
                          <AHStack
                            position={"absolute"}
                            right={"40px"}
                            top={"0"}
                          >
                            <Pressable
                              onPress={() =>
                                Linking.openURL(
                                  slides[
                                    currentIndex
                                  ]?.media?.orgFile?.startsWith("GoogleDrive")
                                    ? slides[currentIndex]?.media?.linkURL
                                    : slides[currentIndex]?.media?.orgFile,
                                )
                              }
                            >
                              <img
                                src="https://www.shutterstock.com/image-vector/external-link-icon-on-grey-260nw-2005883333.jpg"
                                height={"50px"}
                                width={"50px"}
                              />
                            </Pressable>
                          </AHStack>
                        )}
                      </AHStack>
                    )}

                    {fullscreen && !isCommentSlider && (
                      <AHStack position={"absolute"} right={"0"} top={"0"}>
                        <Pressable
                          style={{ position: "absolute", right: "0", top: "0" }}
                          onPress={() => {
                            setIsCommentSlider(false);
                            setIsFullScreen(false);
                          }}
                        >
                          <img
                            src={normalscreen}
                            height={"25px"}
                            width={"25px"}
                          />
                        </Pressable>
                      </AHStack>
                    )}

                    {slides[currentIndex]?.media?.type === "iframe" ? (
                      <iframe
                        src={imageeeUrl}
                        className={
                          !fullscreen
                            ? "detail_image"
                            : fullscreen && isMobile
                              ? "detail_image_mobile"
                              : "full_image"
                        }
                      ></iframe>
                    ) : slides[currentIndex]?.media?.type === "linkPreview" ? (
                      <SimpleLinkPreview
                        url={slides[currentIndex]?.media}
                        setClickedUrl={setClickedUrl}
                        setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                      />
                    ) : slides[currentIndex]?.media?.type?.startsWith(
                        "image",
                      ) ||
                      slides[currentIndex]?.media?.type == "Onedrive" ||
                      slides[currentIndex]?.media?.type === "dropbox" ? (
                      <img
                        src={imageeeUrl}
                        alt="slide"
                        className={
                          !fullscreen
                            ? "detail_image"
                            : fullscreen && isMobile
                              ? "detail_image_mobile"
                              : "full_image"
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      borderRadius: "10px",
                      backgroundSize: "contain",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  >
                    {slides[currentIndex]?.media?.orgFile?.startsWith(
                      "GoogleDrive",
                    ) ? (
                      <iframe
                        src={imageeeUrl}
                        style={{
                          width: "80%",
                          height: "80%",
                          borderRadius: "10px",
                        }}
                      ></iframe>
                    ) : (
                      <img
                        src={imageeeUrl}
                        alt="slide"
                        style={{
                          width: "80%",
                          height: "80%",
                          borderRadius: "10px",
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            )}
          {previewitem?.media?.id &&
            (previewitem?.media?.type?.startsWith("application") ||
              previewitem?.media?.type === "text/plain") && (
              <>
                {slides?.length > 0 ? (
                  <div
                    className={
                      fullscreen
                        ? "fullscreen-image-container"
                        : isHeader
                          ? "image-containerHeader"
                          : "image-container"
                    }
                  >
                    {isHeader && (
                      <AHStack position={"absolute"} right={"0"} top={"0"}>
                        <Pressable
                          onPress={() => {
                            setShowPreview(false);
                            setHeader(false);
                          }}
                        >
                          <CloseIcon size="15px" color={"white"} />
                        </Pressable>
                      </AHStack>
                    )}

                    <AHStack position={"absolute"} right={"3%"} top={"-1%"}>
                      <Tooltip openDelay={500} label={"Download"}>
                        <Pressable
                          onPress={() => {
                            handledocument(previewitem);
                          }}
                        >
                          <DownloadIcon height={"25px"} width={"25px"} />
                        </Pressable>
                      </Tooltip>
                    </AHStack>
                    <img
                      src={imageeeUrl}
                      alt="slide"
                      className={
                        !fullscreen
                          ? "detail_image"
                          : fullscreen && isMobile
                            ? "detail_image_mobile"
                            : "full_image"
                      }
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      borderRadius: "10px",
                      backgroundSize: "contain",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  >
                    <img
                      src={imageeeUrl}
                      alt="slide"
                      style={{
                        width: "80%",
                        height: "80%",
                        borderRadius: "10px",
                      }}
                    />
                  </div>
                )}
              </>
            )}
          {previewitem?.media?.id &&
            previewitem?.media?.type?.startsWith("video") && (
              <div className={"video-slide"}>
                {!fullscreen &&
                  !isHeader &&
                  !slides[currentIndex]?.media?.linkURL && (
                    <AHStack position={"absolute"} right={"0"} top={"0"}>
                      <Pressable
                        onPress={() => {
                          setIsFullScreen(true);
                        }}
                      ></Pressable>
                    </AHStack>
                  )}

                {isHeader && (
                  <AHStack
                    position={"absolute"}
                    right={"10%"}
                    top={"10%"}
                    zIndex={999}
                  >
                    <Pressable
                      onPress={() => {
                        setShowPreview(false);
                        setHeader(false);
                      }}
                    >
                      <CloseIcon size="15px" color={"white"} />
                    </Pressable>
                  </AHStack>
                )}

                {fullscreen && (
                  <AHStack position={"absolute"} right={"0"} top={"0"}>
                    <Pressable
                      style={{ position: "absolute", right: "0", top: "0" }}
                      onPress={() => {
                        setIsCommentSlider(false);
                        setIsFullScreen(false);
                      }}
                    >
                      <img src={normalscreen} height={"25px"} width={"25px"} />
                    </Pressable>
                  </AHStack>
                )}

                <Box width={"100%"} height={fullscreen ? "100%" : "94%"}>
                  <video
                    controls
                    autoPlay
                    width={"100%"}
                    height={"100%"}
                    src={
                      previewitem?.media?.linkURL
                        ? previewitem?.media?.linkURL
                        : previewitem?.media?.storeId === "ST-USDWLS" ||
                            previewitem?.media?.storeId === "ST-USTWLS" ||
                            previewitem?.media?.storeId === "ST-USCWLS"
                          ? AV.Media.getVideoStreamURL(previewitem?.media)
                          : Media.getURL(previewitem?.media)
                    }
                    className={fullscreen ? "full_video" : ""}
                  />
                </Box>
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default AVImageSlider;
